module.exports = __webpack_public_path__ + "static/Roles-f34e177a6a81e0d44aa0357d4ca2768c.png";